import React from 'react';

/** Grey pill: WhatsApp or SMS when we know how the number was verified / preferred (Reddy-style). */
export default function PhoneChannelPill({ channel }) {
  const c = String(channel || '').toLowerCase().trim();
  if (c !== 'whatsapp' && c !== 'sms') return null;
  const label = c === 'whatsapp' ? '(WhatsApp)' : '(SMS)';
  return (
    <span className="ml-1.5 inline-flex items-center text-[10px] font-medium px-1.5 py-0.5 rounded-full border border-slate-200 bg-slate-100 text-slate-500 whitespace-nowrap align-middle">
      {label}
    </span>
  );
}
